import { isProfessionalInvitePath } from "@/lib/profession-invite-path";

/**
 * Routes that use the full-page navy `bg-primary` shell. All auth / invite /
 * register flows are forced to LIGHT — only authenticated pages respect the
 * user's theme preference.
 *
 * Exact paths vs. prefixes: invite-accept URLs include a `:token` segment, so
 * they are matched by prefix. Keep these lists in sync with the inline theme
 * init script in `index.html`.
 */
const LIGHT_AUTH_SHELL_PATHS = [
  "/login",
  "/register",
  "/auth/verify",
  "/auth/verify-root-invite",
  "/auth/sso/callback",
  "/auth/forgot-password",
  "/auth/reset-password",
  "/onboarding/set-password",
  "/verify-email",
] as const;

/*
  NO PROFESSION NAMES HERE. Invitation acceptance is matched by SHAPE —
  isProfessionalInvitePath covers `accept-<slug>-invitation` for every
  profession in the registry, so a new one does not reach its own signup page
  rendered in the authenticated dark theme. The two entries that used to sit
  at the top of this list were exactly that bug waiting on a third profession.
*/
const LIGHT_AUTH_SHELL_PREFIXES = [
  "/accept-enterprise-invite",
  "/accept-request-invite",
  "/rate",
] as const;

function matchesLight(pathname: string): boolean {
  if ((LIGHT_AUTH_SHELL_PATHS as readonly string[]).includes(pathname)) {
    return true;
  }
  if (isProfessionalInvitePath(pathname)) {
    return true;
  }
  return (LIGHT_AUTH_SHELL_PREFIXES as readonly string[]).some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function isNavyAuthShellPath(pathname: string): boolean {
  return matchesLight(pathname);
}

export function isLightAuthShellPath(pathname: string): boolean {
  return matchesLight(pathname);
}

export function isDarkAuthShellPath(_pathname: string): boolean {
  return false;
}
